import { useGetMyExamCentersQuery } from '@report/graphql';
import {
  FormSearchMultipleSelectionWithSelectAllOption,
  type FormSearchMultipleSelectionWithSelectAllOptionProps,
} from '@shared/components';
import { useMemo } from 'react';
import { type FieldValues } from 'react-hook-form';

type MyExamCenterSearchSelectionProps = Pick<
  FormSearchMultipleSelectionWithSelectAllOptionProps<FieldValues>,
  'name' | 'label' | 'placeholder' | 'sx'
>;

export default function MyExamCenterSearchSelection(
  props: Readonly<MyExamCenterSearchSelectionProps>,
) {
  const { name, label = 'Exam Center', placeholder, sx } = props;

  const { data: examCenterData, loading } = useGetMyExamCentersQuery();

  const options = useMemo(() => {
    const examCenters = [...(examCenterData?.reportGetMyExamCenters?.examCenters ?? [])];
    return examCenters
      .sort((a, b) => a.examCenterId - b.examCenterId)
      .map((examCenter) => ({
        label: examCenter.code,
        value: examCenter.code,
      }));
  }, [examCenterData]);

  return (
    <FormSearchMultipleSelectionWithSelectAllOption
      sx={sx}
      name={name}
      label={label}
      placeholder={placeholder}
      loading={loading}
      slotProps={{
        selectAllOption: {
          label: `Select All (${options.length})`,
        },
      }}
      options={options}
    />
  );
}
